"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HELP = void 0;
var HELP = exports.HELP = process.env.CATALYTIC_HELP_URL || 'https://help.catalytic.com/';
//# sourceMappingURL=url.js.map